import TomSelect from 'tom-select';

function init() {

	const forms = document.querySelectorAll('.smx-booking-form form');

	if(forms.length > 0){
        window.utils.forEach(forms, function (index, form) {

			const serviceSelect = form.querySelector('#smx-service');

			new TomSelect(serviceSelect, {
				placeholder: 'Seleziona un servizio',
				create: false,
				maxItems: 1,
				closeAfterSelect: true,
				render:{
					no_results: function( data, escape ){
						return '<div class="no-results">Nessun risultato</div>';
					},
				},
				onItemAdd: function() {
					this.close();
					const nextInput = document.querySelector('#smx-expert');
					if (nextInput) nextInput.focus();
				},
			});
		})
	}
  
}

export default { init };